<template>
  <v-app>
    <div class="pt-5 mt-5">
      <div class="px-5 mt-5 pt-5">
        <v-col cols="auto">
          <!--                    handel dialog-->
        </v-col>
        <v-card :loading="loading" class="p-3 pt-0">

          <terminal-table class="col-12" :currentPage="data.current_page"
                          :perPage="data.per_page" v-if="isMobile" :getData="getDataForTable"
                          :pageCount="data.last_page"
                          :options="tableProps" :datas="data" :headers="columns"></terminal-table>
          <data-table v-else
                      :data="data"
                      :columns="columns"
                      :debounce-delay="3000"
                      :translate="translate"
                      :orderBy="tableProps.column"
                      :pagination="paginate"
                      :orderDir="tableProps.dir"
                      :per-page="[10, 25, 50, 100, 500]"
                      @on-table-props-changed="reloadTable"
                      :loading="true"
                      class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
          >
            <template slot="filters" slot-scope="{ tableFilters, perPage }">
              <filters-table @getInfo="(val)=>{ if (val) tableProps.search = searchBox.search }"
                             v-model="searchBox"></filters-table>
            </template>
          </data-table>
        </v-card>
      </div>
    </div>
  </v-app>
</template>
<script>
import {dataTableProps} from "@/main";
import button from "@/view/pages/button";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import {debounce} from "../../../custom";
import FiltersTable from "@/components/Table/filtersTable";

export default {
  name: "payMonitotoring",
  components: {FiltersTable, TitleRibbon},
  data() {
    return {
      dialog: false,
      translate: dataTableProps.translate,
      tableProps: dataTableProps.tableProps,
      paginate: dataTableProps.pagination,
      groupModal: false,
      chargeMount: '',
      numbersInfo: false,
      loading: false,
      selectedNumber: [],
      dataId: '',
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'کاربر',
          name: 'user.name',
          primary: true,
          transform(val) {
            return val.data.user.name + ' ' + val.data.user.lastName
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'شماره',
          name: 'phone',
          transform: (val) => {
            return val.data.phone ? val.data.phone : 'وجود ندارد';
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'نام کاربری',
          name: 'user.name',
          transform(val) {
            return val.data.user.name + ' ' + val.data.user.lastName
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'مبلغ',
          name: 'price',
          transform: (val) => {
            return val.data.price ? val.data.price : '0'
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'تاریخ ',
          name: 'created_at_p',
          transform: (val) => {
            return val.data.created_at_p ? val.data.created_at_p : '-'
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'وضعیت ',
          primary: true,
          name: 'status',
          transform: (val) => {
            const color = val.data.status == 'success' ? 'success' : 'danger'
            const text = val.data.status == 'success' ? 'موفق' : 'ناموفق'
            return `<span class="badge badge-${color}" >${text}</span>`
          },
          orderable: true,
          searchable: true,
        },
      ],
      data: {},
      url: `${url}/admin/monitoring/charges`,
      searchBox: {
        search: '',
        length: 10
      },
    }
  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true;
      $.ajax({
        url: url,
        fn: this.getDataForTable,
        type: 'GET',
        data: Object.assign({}, query, {search:this.tableProps.search,length:this.searchBox.length}),
        headers: {
          "ACCEPT": "application/json",
          "Authorization": Token
        },
        success: function (data) {
          vm.data = data;
          vm.loading = false;
        }
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 700);
    },
    actions(data, type) {
    },
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getDataForTable(this.url);
          return true
        case 'sm':
          this.getDataForTable(this.url);
          return true
        case 'md':
          this.getDataForTable(this.url);
          return false
        case 'lg':
          this.getDataForTable(this.url);
          return false
        case 'xl':
          this.getDataForTable(this.url);
          return false
      }
    },
  },
  watch: {
    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true
    }
  },
  mounted() {
    this.tableProps = {
      search: '',
      length: 10,
      column: 'id',
      dir: 'desc',
      page: 1,
    };
    this.getDataForTable(this.url)

    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    })
  },
}
</script>

<style scoped>

</style>